
    import './styles.scoped.css';
    export default {
  "link": "awsui_link_1kosq_139vj_5",
  "breadcrumb": "awsui_breadcrumb_1kosq_139vj_9",
  "icon": "awsui_icon_1kosq_139vj_12",
  "anchor": "awsui_anchor_1kosq_139vj_16",
  "last": "awsui_last_1kosq_139vj_57",
  "compressed": "awsui_compressed_1kosq_139vj_67",
  "text": "awsui_text_1kosq_139vj_71"
};
  